'use client'

import { SocialLinks } from '@/types/typo3/Footer'
import { ButtonSocial, Icon } from '@/ui/components'

interface Props {
  data: SocialLinks
}

const Socials = ({ data }: Props) => {
  if (!data?.menu.length) {
    return null
  }

  return (
    <ButtonSocial.Wrapper>
      {data?.menu?.map((item, index) => (
        <ButtonSocial.Item key={index?.toString()} href={item.link}>
          <Icon icon={item.icon} />
        </ButtonSocial.Item>
      ))}
    </ButtonSocial.Wrapper>
  )
}

export default Socials
